import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AuthorityData {
  authorityType: 'INTERNA' | 'ESTERNA' | 'OTHER' | null;
  authorityTypeOther: string;
  authorityName: string;
  authorityEmail: string;
  authorityPhone: string;
  technicalReferent: string;
  greenCertifications: string;
}

export interface OtherFieldsData {
  solCode: string;
  networkName: string;
  networkDescription: string;
  networkOrigin: string;
  webVisibility: boolean;
  ars: boolean;
  tier1: boolean;
  estimator: boolean;
  alphscaleActive: boolean;
  registryInsertionDate: Date | null;
  lastRenegotiationDate: Date | null;
  sc: string;
  scReferent: string;
  repairInterventionsCount: string;
  axaCommercialArea: string;
  notPublishedInAxa: boolean;
  exCode: string;
  communicationEmail: boolean | null;
  secondaryBusinessName: string;
  contract: string;
  expert: string;
  oldEmail: string;
  assignedCompanies: string;
  synergiesInternationalPaintlessDentRepairCompaniesCount: number | null;
  synergiesNationalPaintlessDentRepairCompaniesCount: number | null;
}

export interface ProfessionalOperationalData {
  authority: AuthorityData;
  otherFields: OtherFieldsData;
}

export interface ProfessionalOperationalDetailsResponse {
  status: boolean;
  message: string;
  data: ProfessionalOperationalData | null;
}

@Injectable({
  providedIn: 'root',
})
export class ProfessionalOperationalDetailsService {
  private http = inject(HttpClient);
  private readonly API_BASE_URL = 'api/v1/professionals';

  /**
   * Load operational details for a professional (authority + altri campi)
   */
  getOperationalDetails(professionalId: string): Observable<ProfessionalOperationalDetailsResponse> {
    return this.http.get<ProfessionalOperationalDetailsResponse>(
      `${environment.professionalsApiUrl}/${this.API_BASE_URL}/${professionalId}/operational-details`
    );
  }

  /**
   * Save (upsert) operational details for a professional
   */
  saveOperationalDetails(professionalId: string, data: ProfessionalOperationalData): Observable<ProfessionalOperationalDetailsResponse> {
    return this.http.put<ProfessionalOperationalDetailsResponse>(
      `${environment.professionalsApiUrl}/${this.API_BASE_URL}/${professionalId}/operational-details`,
      data
    );
  }
}
